<template>
    <div>
       <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Dodatni sadržaji</h5><br>
                <button
                        type="button"
                        class="btn btn-lg btn-primary"
                        @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                        v-if="show_datatable"
                        :url="datatables_url"
                        :settings="datatables.settings"
                        :title="datatables.title"
                        @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>

</template>

<script>
import Datatables from "@/components/datatable/Datatables";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";

export default {
    name: "SkupoviDodatniSadrzaji",
    components: {
        Datatables,
        SkupoviNavigation
    },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'skup-dodatni-sadrzaj',
            datatables: {},
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id
        }
    },
    methods:{
        rowClick( row ){
            this.$router.push( { path: '/skupovi/' + this.skup_id + '/dodatni-sadrzaji/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/skupovi/' + this.skup_id + '/dodatni-sadrzaji/create' } )
        },

        setDatatable() {
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'skup_id',
                            'visible': false,
                            'filter':{
                                'type': 'none',
                                'value': vm.skup_id
                            },
                        },
                        {
                            'id': 'dodatni_sadrzaji.naziv',
                            'title': 'Kotizacija',
                            'searchable' : false,
                            'column_visibility_group': {
                                id: 'dodatni_sadrzaj',
                            }
                        },
                        {
                            'id': 'dodatni_sadrzaji.opis',
                            'title': 'Kotizacija - opis',
                            'searchable' : false,
                            'column_visibility_group': {
                                id: 'dodatni_sadrzaj',
                            }
                        },
                        {
                            'id': 'cijena',
                            'title': 'Cijena',
                            'searchable' : false,
                            'column_visibility_group': {
                                id: 'dodatni_sadrzaj',
                            }
                        },
                        {
                            'id': 'porezi.postotak',
                            'searchable' : false,
                            'title': 'Porez',
                            'column_visibility_group': {
                                id: 'dodatni_sadrzaj',
                            }
                        },
                        {
                            'id': 'napomena',
                            'searchable' : false,
                            'title': 'Napomena',
                            'column_visibility_group': {
                                id: 'dodatni_sadrzaj',
                            }
                        },

                    ],
                    column_visibility_groups:{
                        'dodatni_sadrzaj' : 'Dodatni sadržaj'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Dodatni sadržaj',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/dodatni-sadrzaji',
                    name: 'Dodatni sadržaj'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>